import { CountUp } from "../../../../lib/countUp";
import GameUtil from "../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LvEffectComp extends cc.Component {

    @property(cc.Label)
    curLv:cc.Label = null;

    @property(cc.Label)
    upLvLab:cc.Label = null;

    @property(cc.Label)
    goldLab:cc.Label = null;

    initLvEffectComp(json:any){

        this.curLv.string = json.userLevelBefore;
        this.upLvLab.string = json.userLevelCurrent;

        let gold = 0;
        for (let i = 0; i < json.awardList.length; i++) {
            let award = json.awardList[i];
            gold += award.expAwardNum;
        }
        if (this.gameNodeIsValid(this.node)) {
            let v = GameUtil.currencyFormatting(Number(gold),2,true);
            this.goldLab.string = v;
        }
    }

    private gameNodeIsValid(node:cc.Node){
        if (node != null && cc.isValid(node, true)) {
            return true;
        }
        return false;
    }

}
